import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DataService } from "../../services/data/data.service";

// Services.
import { LoggerService } from "../../services/logger/logger.service";

// Classes.
import { Logger } from "../../classes/logger";
import { IndexItem } from "../../classes/indexItem";
import { ActivatedRoute } from "@angular/router";
import {Subscription} from 'rxjs';
import {first} from 'rxjs/operators';

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"]
})
export class IndexComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() root: string;
  @Input() parentId: string;

  public index: IndexItem;

  protected logger: Logger;

  /**
   * A variable to check if this is an ionic app because query params are used.
   *
   * @type {boolean}
   * @memberof IndexComponent
   */
  public isIonicApp: boolean = false;

  public subscription: Subscription;
  constructor(
    private dataService: DataService,
    loggerSrvc: LoggerService,
    private route: ActivatedRoute
  ) {
    this.logger = new Logger(loggerSrvc, this.constructor.name);
  }

  ngOnInit() {
    this.getIndex();
    this.route.queryParams.pipe().subscribe(next => {
    this.subscription = this.route.queryParams.pipe().subscribe(next => {
      if (next["book_title"]) {
        this.isIonicApp = true;
      }
    });
  });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getIndex(): void {
    this.dataService.getIndex(this.root).subscribe(
      data => {
        this.index = data;
      },
      error => this.processError(error)
    );
  }

  protected processError(error: any) {
    this.logger.error(`Error in ${this.constructor.name} (F4E6B011)`, error);
  }
}
